<header class="app-header navbar">
  <button class="navbar-toggler d-lg-none" type="button" appMobileSidebarToggler>
    <span class="navbar-toggler-icon"></span>
  </button>
  <a class="navbar-brand" [style.backgroundImage]="logo()" href="#"></a>

  @if(user) {
    <ul class="nav navbar-nav ms-auto mt-3 user-nav">
      <li class="nav-item dropdown">
        @if (user.firstName && user.lastName) {
          <a
            class="nav-link dropdown-toggle nav-link"
            data-bs-toggle="dropdown"
            href="#"
            role="button"
            aria-haspopup="true"
            aria-expanded="false"
            >
            <ngx-avatars [name]="user.firstName + ' ' + user.lastName" size="30" class="d-inline-block"></ngx-avatars>
            {{ user.firstName + " " + user.lastName }}
          </a>
        }
        @if (!user.firstName || !user.lastName) {
          <a
            class="nav-link dropdown-toggle nav-link"
            data-bs-toggle="dropdown"
            href="#"
            role="button"
            aria-haspopup="true"
            aria-expanded="false"
            >
            <ngx-avatars [name]="user.firstName + ' ' + user.lastName" size="30"></ngx-avatars>
            <span class="d-none d-md-inline">{{ user.username }}</span>
          </a>
        }
        <div class="dropdown-menu dropdown-menu-right">
          <!--
          <div class="dropdown-header">
            <strong>Settings</strong>
          </div>
          -->
          <a class="dropdown-item" routerLink="/users/{{ user.id }}"><i class="fas fa-user me-2"></i> Profile</a>
          <!-- <a class="dropdown-item disabled" href="#"><i class="fas fa-cogs me-2"></i> Preferences</a> -->
          <a class="dropdown-item" href="#" (click)="logout()"><i class="fas fa-sign-out me-2"></i> Logout</a>
        </div>
      </li>
    </ul>
  }
</header>
